// src/components/Ouvidoria/PolicyModal.js
import React from 'react';

const PolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>&times;</button>
        <h3>Política de Uso e Confidencialidade do Canal de Ouvidoria</h3>
        
        <div className="policy-content">
          <p>Este documento descreve os termos de uso deste Canal, assegurando um ambiente seguro, confidencial e em conformidade com a legislação vigente, incluindo a Lei Geral de Proteção de Dados (LGPD).</p>

          <h4>1. Finalidade do Canal</h4>
          <p>Este Canal destina-se exclusivamente ao recebimento de sugestões, elogios, reclamações, denúncias de irregularidades, atos ilícitos ou qualquer conduta que viole o código de ética da empresa, a legislação ou as políticas internas.</p>

          <h4>2. Garantia de Anonimato e Confidencialidade</h4>
          <p>Asseguramos o direito ao anonimato a todos os manifestantes. Caso opte por se identificar, garantimos a confidencialidade total de suas informações de identidade, que serão acessadas unicamente pela equipe de gestão responsável pela apuração, sob estrito dever de sigilo.</p>

          <h4>3. Declaração de Não Retaliação</h4>
          <p>A empresa proíbe expressamente qualquer tipo de retaliação, intimidação ou ação disciplinar contra qualquer pessoa que, de boa-fé, relate uma preocupação ou denúncia. Atos de retaliação serão tratados como uma violação grave de nossas políticas e estarão sujeitos a medidas disciplinares.</p>

          <h4>4. Tratamento de Dados (LGPD)</h4>
          <p>Ao se identificar, você consente que seus dados (nome e e-mail) sejam coletados e tratados com a finalidade exclusiva de permitir o contato para esclarecimentos adicionais e para fornecer um retorno sobre a sua manifestação. Os dados serão armazenados de forma segura, com acesso restrito, e não serão utilizados para nenhuma outra finalidade. As informações serão retidas apenas pelo tempo necessário para a completa apuração e resolução da manifestação, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).</p>

          <p style={{ marginTop: '2rem', fontStyle: 'italic' }}>Ao utilizar este canal, você declara que leu e concorda com os termos desta política.</p>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;